<style >
  .searchresult em {
    background-color: goldenrod;
  }
</style>
<template>
<v-card flat >
  <v-toolbar dark flat>
    <v-icon >help</v-icon>
    <v-toolbar-title>GuruSupport</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn @click='$emit("close")' icon ><v-icon>close</v-icon></v-btn>
  </v-toolbar>
  <v-divider></v-divider>
  <v-card-title class="pa-0" >
    <template v-if="step===1" >
      <v-btn small flat icon @click="step=0" >
        <v-icon small >keyboard_backspace</v-icon>
      </v-btn>
      <v-divider vertical ></v-divider>
    </template>

    <v-text-field clearable persistent-hint
      v-model="search"
      @input="doSearch"
      hint="Type a query to search our online knowledgebase"
      prepend-icon="search"
      class="mx-1 mb-2"
      placeholder="How do I .." />
    <v-spacer/>
  </v-card-title>

  <v-card-text >
<!--
TODO:
1. Style up results:
  [ ]  Probably use cards
  [ ] Highlight search term in results
  [ ] Pagination
  [ ] Description of search results at top
  [ ] Provide a link to open_in_new (use that icon) which opens in the help docs

2. Show article detail if they click on it:
  [ ] increment step as per below
  [ ] Set the selected articcle and display it in the second window-item (below)
  [ ] If they type something into the search box, you must go back to results

3. For extra points:
  [ ] Debounce the search request to prevent excessive requests

Resources:
* Help Docs website: help.appointmentguru.co
* Debounce: https://gist.github.com/toast38coza/ef4252461d49f87fa8670794ecf5d2b2
-->

    <v-window v-model="step" vertical >
      <v-window-item class="searchresult" >
        <template v-if="results && results.hits" >
          <v-subheader class="overline pa-0" >Search results
            <span v-if="search && search.length > 0" class="ml-1" > for <i>{{search}}</i></span>
          </v-subheader>
          <small class='text-xs text-gray-400 ml-3' v-if='pageCount === 1'>
            {{results.nbHits}} results returned in {{results.processingTimeMs}}ms
          </small>
          <small class='text-xs text-gray-400 ml-3' v-else-if='pageCount > 1'>
            Showing Page {{pageNumber}} of {{results.nbHits}} results returned in {{results.processingTimeMs}}ms
          </small>
          <small class='text-xs text-gray-400 ml-3' v-else>
            0 results returned in {{results.processingTimeMs}}ms
          </small>

          <div v-for="result in paginatedData" :key="result.id" >
            <v-card dark class="grey darken-2 mt-2">

              <v-list dense dark >
                <v-list-tile >
                  <v-list-tile-content>
                    <v-list-tile-title v-text="result._formatted.title" >
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action >
                    <v-btn small icon
                      :href="`https://help.appointmentguru.co/${result._formatted.slug}.html`"
                      target="_blank" >
                      <v-icon small >open_in_new</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-action class="ml-0" v-if="result.video_embed_url">
                    <v-btn small icon
                      @click="selectedVideo=result" >
                      <v-icon small >videocam</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>

              <!-- <v-card-title class='overline py-1 darken-2'>
                <v-spacer/>
                <v-btn small icon
                  :href="`https://help.appointmentguru.co/${result._formatted.slug}`"
                  target="_blank" >
                  <v-icon small >open_in_new</v-icon>
                </v-btn>
              </v-card-title> -->
              <v-divider/>
              <v-card-text v-if="result && result._formatted"
                v-html="formatSummary(result._formatted.summary)" />

              <v-divider ></v-divider>

              <v-card-actions >
                <v-spacer/>
                <v-btn small flat @click="setSelectedArticle(result)" >More
                  <v-icon small >chevron_right</v-icon>
                </v-btn>
              </v-card-actions>


            </v-card>

            <v-card v-show="result.articleVisibility">
              <v-card-title class='subheading secondary darken-1'>
                Article Fetched: {{result.title}}
              </v-card-title>
              <v-card-text>
                Fetched Article To Come Here
              </v-card-text>
            </v-card>

          </div>
          <div class="text-center">
            <v-pagination v-model="pageNumber" :length="pageCount" @input="nextPage"/>
          </div>
        </template>

      </v-window-item >


      <v-window-item >
        <v-card flat dark v-if="selectedArticle" >
          <v-toolbar dense >
            <v-btn small icon @click="step--" >
              <v-icon small>chevron_left</v-icon>
            </v-btn>
            <v-toolbar-title v-text="selectedArticle.title" />
            <v-spacer/>
            <v-btn small icon
              :href="`https://help.appointmentguru.co/${selectedArticle.slug}.html`"
              target="_blank" >
              <v-icon small >open_in_new</v-icon>
            </v-btn>
          </v-toolbar>

          <v-divider class="py-2" />
          <div v-html="selectedSummary" />

          <iframe
            v-if="selectedEmbed"
            :src="selectedEmbed"
            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%;" >
          </iframe>

          <div v-text="selectedContent" />
          <!-- <pre v-text="selectedArticle" /> -->
        </v-card>

      </v-window-item >

    </v-window>


    <v-card flat class="my-2" >
        <v-card-title dark flat class="overline py-1 justify-center" >
          Still need help?
        </v-card-title>

        <v-btn block outline outlined dark
          class="mt-2"
          href='https://help.appointmentguru.co/' target="_blank" >
          Open Knowledgebase
          <v-icon class="ml-2" small >open_in_new</v-icon>
        </v-btn>
        <v-btn block outline outlined dark
          class="mt-2"
          href='https://help.appointmentguru.co/' target="_blank" >
          Email support
          <v-icon small class="ml-2" >email</v-icon>
        </v-btn>
        <v-btn block outline outlined
          class="mt-2"
          href='https://book.appt.guru/?s=9' target="_blank" >
          Book a demo
          <v-icon class="ml-2" small >open_in_new</v-icon>
        </v-btn>
      </div>
    </v-card>

  </v-card-text>

  <v-dialog
    v-if="selectedVideo"
    v-model="selectedVideo"
    width="680"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    flat dark >
    <v-card flat dark>
      <v-card-title class="overline py-1" >
        {{selectedVideo.title}}
        <v-spacer/>
        <v-btn small icon @click="selectedVideo=null" ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <!-- <v-btn absolute top right small fab class="mt-5" @click="selectedVideo = false" ><v-icon>close</v-icon></v-btn> -->
      <!-- <pre v-text="selectedVideo" /> -->
      <div style="position: relative; padding-bottom: 70.45009784735812%; height: 0;">
        <iframe
          v-if="selectedVideo"
          :src=selectedVideo
          frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" >
        </iframe>
      </div>

      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="selectedVideo = false" >
          Close
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>

</v-card>
</template>
<script>
// import axios from 'axios'
// import Tut from '@/components/help/Tut'
import marked from 'marked'
// import Vue from 'vue'

const URL = 'https://ms-fcc589b57cf6-156.saas-nyc.meili.dev'
const KEY = 'f63f5d0cfa4a742401f88a450eaa01e5f054554cf9324a2e7453cb91cc5d0bcc'
// const getCircularReplacer = () => {
//   const seen = new WeakSet()
//   return (key, value) => {
//     if (typeof value === 'object' && value !== null) {
//       if (seen.has(value)) {
//         return
//       }
//       seen.add(value)
//     }
//     return value
//   }
// }

export default {
  name: 'ContextualHelp',
  // components: {Tut},
  props: {
    context: { type: String },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      search: null,
      results: [],
      articleWindows: [],
      fecthedArticle: null,
      pageNumber: 1,
      size: 5,
      timeout: null,
      selectedArticle: null,
      selectedVideo: false
    }
  },
  mounted () {
    this.doSearch()
  },
  computed: {
    headers () {
      return {
        'Content-Type': 'application/json;charset=utf-8',
        //  'Authorization': 'Bearer ' + KEY,
        'X-MEILI-API-KEY': KEY
      }
    },
    query () {
      return {
        q: this.search,
        matches: true,
        attributesToHighlight: [
          'title',
          'summary',
          'content'
        ]
      }
    },
    pageCount () {
      if (this.results.hits != null) {
        return Math.ceil(this.results.hits.length / this.size)
      } else {
        return 0
      }
    },
    paginatedData () {
      if (this.results.hits) {
        return this.results.hits.slice(this.pageNumber * this.size - this.size, this.pageNumber * this.size - this.size + this.size)
      }
    },
    selectedSummary () {
      marked.setOptions({sanitize: true})
      let content = this.getObjectPath(this.selectedArticle, 'summary', '')
      if (content) { return marked(content) }
      return content
    },
    selectedContent () {
      marked.setOptions({sanitize: true})
      let content = this.getObjectPath(this.selectedArticle, 'content', '')
      if (content) { return marked(content) }
      return content
    },
    selectedEmbed () {
      return this.getObjectPath(this.selectedArticle, 'video_embed_url', null)
    }
  },
  watch: {
    search () {
      this.step = 0
    }
  },
  methods: {
    debounceExpensiveMethod () {
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(this.doSearch, 1000)
    },
    async doSearch () {
      let options = {
        body: JSON.stringify(this.query),
        method: 'post',
        headers: this.headers
      }
      let url = URL + '/indexes/articles/search'
      const res = await fetch(url, options)
      this.results = await res.json()
    },
    showDetails (result) {
      this.$set(result, 'detailsVisibility', !result.detailsVisibility)
    },
    async articleRequest (articleUrl) {
      let options = {
        method: 'get'
        // headers: this.headers
      }
      let url = articleUrl
      const res = await fetch(url, options)
      this.results = await res.json()
    },
    fetchArticle (result) {
      console.log('Fetching Article ' + result.id)
      this.$set(result, 'articleVisibility', !result.articleVisibility)
      this.articleRequest('https://help.appointmentguru.co/' + result._formatted.slug)
    },
    setSelectedArticle (result) {
      this.selectedArticle = result
      this.step++
    },
    nextPage (page) {
      this.pageNumber = page
    },
    extractString (obj) {
      var seen = []
      JSON.stringify(obj, function (key, val) {
        if (val != null && typeof val === 'object') {
          if (seen.indexOf(val) >= 0) {
            return
          }
          seen.push(val)
        }
        return val
      })
    },
    formatSummary (text) {
      marked.setOptions({sanitize: true})
      return marked((text))
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?a789fd00